import { render, staticRenderFns } from "./SettingsAuthority.vue?vue&type=template&id=05614d8d&scoped=true&"
import script from "./SettingsAuthority.vue?vue&type=script&lang=js&"
export * from "./SettingsAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05614d8d",
  null
  
)

export default component.exports